export const CHART_TYPE_STORAGE_KEY = "deployment-frequency";
